import { useAtomValue } from "jotai";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  ThemeProvider as StyledThemeProvider,
  styled,
} from "styled-components";
import "./App.css";
import AppHeader from "./components/AppHeader/AppHeader";
import { StornoDialogContainer } from "./containers/StornoDialogContainer";

import { panelIsOpenState } from "./store";

import {
  FluentProvider,
  webDarkTheme,
  webLightTheme,
} from "@fluentui/react-components";
import { AppSpinner } from "components/AppSpinner/AppSpinner";
import { useResizeObserverDevErrorFix } from "hooks/useResizeObserverDevErrorFix";
import { ROUTES } from "library/constants";
import { useEffect, useState } from "react";
import { allThemes } from "theme";
import { EThemeMode, EThemeName, IStyledTheme } from "theme/types";
import grecoTriangleBg from "./assets/GrECoGraphicTriangles.svg";
import { useGetUserAppTargetSetting } from "hooks/useGetUserAppTargetSetting";
import { useGetTaxonomies } from "state/queries/useGetTaxonomies";
import OfferList from "pages/OfferList/OfferList";
import { UnauthorizedPage } from "pages/UnauthorizedPage/UnauthorizedPage";
import { EAppSettings } from "library/types";
import ItemPage from "pages/ItemPage/ItemPage";

function App() {
  useResizeObserverDevErrorFix();

  const location = window.location;
  const is403Page = location.pathname === ROUTES.UNAUTHORIZED_PAGE;
  const { data: taxonomies } = useGetTaxonomies(!is403Page);
  const panelIsOpen = useAtomValue(panelIsOpenState);
  const darkModeAppSetting = useGetUserAppTargetSetting({
    targetSettingName: EAppSettings.DARK_MODE,
  });

  const darkMode = darkModeAppSetting?.userAppSettingValue === "true";

  const themeAppSetting = useGetUserAppTargetSetting({
    targetSettingName: EAppSettings.THEME,
  });
  const selectedThemeName =
    themeAppSetting?.userAppSettingValue || EThemeName.main;

  const [appTheme, setAppTheme] = useState<IStyledTheme>(
    allThemes[selectedThemeName][darkMode ? EThemeMode.dark : EThemeMode.light]
  );

  const [fluentTheme, setFluentTheme] = useState(
    darkMode ? webDarkTheme : webLightTheme
  );

  useEffect(() => {
    const fluentTheme = darkMode ? webDarkTheme : webLightTheme;
    setAppTheme(
      allThemes[selectedThemeName][
        darkMode ? EThemeMode.dark : EThemeMode.light
      ]
    );
    setFluentTheme(fluentTheme);
  }, [darkMode, selectedThemeName]);

  return (
    <div className="App">
      <FluentProvider theme={fluentTheme}>
        <StyledThemeProvider theme={appTheme}>
          {!taxonomies && !is403Page && <AppSpinner />}
          <BrowserRouter>
            <AppHeader />
            <Container $isPanelOpen={panelIsOpen}>
              <Routes>
                <Route path={`${ROUTES.HOME}`} element={<OfferList />} />{" "}
                <Route
                  path={ROUTES.UNAUTHORIZED_PAGE}
                  element={<UnauthorizedPage />}
                />
                <Route path={ROUTES.ITEM_PAGE} element={<ItemPage />} />
                <Route path={ROUTES.ITEM_PAGE_DETAIL} element={<ItemPage />} />
              </Routes>
            </Container>
            <ToastContainer
              style={{
                zIndex: 9999999,
              }}
            />
            {/* Add the StornoDialogContainer to handle storno functionality */}
            <StornoDialogContainer />
          </BrowserRouter>
        </StyledThemeProvider>
      </FluentProvider>
    </div>
  );
}

export default App;

const Container = styled("div")<{ $isPanelOpen: boolean }>`
  position: absolute;
  overflow: auto;
  top: 50px;
  left: 0;
  bottom: 0;
  right: 0;
  // width: ${({ $isPanelOpen }) =>
    $isPanelOpen ? "calc(100% - 340px)" : "100%"};
  width: 100%;
  background-color: ${(props) => props.theme.palette.themeBackground};

  background-image: url("${grecoTriangleBg}");
  background-size: auto;
  background-position-x: right;
  background-position-y: bottom;
  background-repeat: no-repeat;
`;
